import { Flex, Image, Text, VStack } from "@chakra-ui/react"
import { DateTime } from "luxon"

import lockGrey from "#/assets/lock-grey.svg"
import {
  selectDepositActionNewLockDuration,
  selectDepositActionToken,
  selectDepositActionUserAmount,
  setNewLockDuration,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import { LOCK_TIMES } from "#/shared/constants"

import DepositDurationBox from "../Deposit/DepositDuration/DepositDurationBox"

const getNewUnlockTime = (duration: number) => {
  const currentDate = new Date()
  currentDate.setUTCHours(currentDate.getUTCHours())

  const currentTime = DateTime.fromJSDate(currentDate)

  const newUnlockTime = currentTime
    .plus({ weeks: duration })
    .toFormat("MMM dd, yyyy")

  return newUnlockTime
}

export default function BoostModalBoostDuration() {
  const userAmount = useDappSelector(selectDepositActionUserAmount)
  const newLockDuration = useDappSelector(selectDepositActionNewLockDuration)
  const lockupTime = useDappSelector(selectDepositActionNewLockDuration)
  const token = useDappSelector(selectDepositActionToken)

  const dispatch = useDappDispatch()

  const newUnlockTime = getNewUnlockTime(newLockDuration)

  if (!token) return null

  return (
    <>
      <Flex
        w="100%"
        justifyContent="space-between"
        gap={4}
        mb={2}
        color="primary.black.70"
        pr={2}
      >
        <Text variant="body">Extend lock period</Text>
        <Flex gap={1} alignItems="center">
          <Image src={lockGrey} />
          <Text variant="body">{newUnlockTime}</Text>
        </Flex>
      </Flex>
      <VStack gap={4} mb={10}>
        {LOCK_TIMES.map(({ period, multiplier }) => (
          <DepositDurationBox
            key={period}
            token={token}
            multiplier={multiplier}
            isActive={lockupTime === period}
            duration={period}
            onClick={() => dispatch(setNewLockDuration(period))}
            userAmount={userAmount}
            extendBoost
          />
        ))}
      </VStack>
    </>
  )
}
